import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface TsIntroVideoConfig {
  tsIntroVideoLink: string;
}

export const TsIntroVideoConfig: TsIntroVideoConfig = {
  tsIntroVideoLink: environment.tsIntro,
};

export const TSINTRO_VIDEO_LINK = new InjectionToken<TsIntroVideoConfig>('TsIntroVideoConfig');
